import { initializeApp } from "firebase/app";
import { getStorage } from 'firebase/storage';
import { getMessaging, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDpIU1e_YiME9dj2qE55p6neOsryG15saY",
  authDomain: "wvivu-prod.firebaseapp.com",
  projectId: "wvivu-prod",
  storageBucket: "wvivu-prod.firebasestorage.app",
  messagingSenderId: "612127956415",
  appId: "1:612127956415:web:421808409eb76ca201d50a",
  measurementId: "G-8MV77HY3K0"
};

// các tham số này là phần config lấy ra được từ phần 2. setting firebase nhé
const app = initializeApp(firebaseConfig)

export const storage = getStorage(app)

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);

toast.success('🦄 Xin chào, Quản trị', {
  position: "top-right",
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);

  const title = payload.data.message;

  document.querySelector('#tingting') && document.querySelector('#tingting').click()

  toast.info(title, {
    position: "bottom-right",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  // ...
});

export default app;
